import { ArrowRight } from "lucide-react";

type ScoreboardActionRowProps = {
    isShareDisabled: boolean;
    isNextBusy: boolean;
    onShareScore: () => void;
    onNextPuzzle: () => void;
};

function ShareGlyph({ size = 12, color = "#fff" }: { size?: number; color?: string }) {
    return (
        <svg width={size} height={size} viewBox="0 0 16 16" fill="none" aria-hidden="true">
            <circle cx="12" cy="3.5" r="2" stroke={color} strokeWidth="1.4" />
            <circle cx="4" cy="8" r="2" stroke={color} strokeWidth="1.4" />
            <circle cx="12" cy="12.5" r="2" stroke={color} strokeWidth="1.4" />
            <line x1="5.7" y1="7.1" x2="10.3" y2="4.4" stroke={color} strokeWidth="1.4" />
            <line x1="5.7" y1="8.9" x2="10.3" y2="11.6" stroke={color} strokeWidth="1.4" />
        </svg>
    );
}

/**
 * Share score + Next puzzle actions between Community Stats and the score/comment list.
 */
export default function ScoreboardActionRow({
    isShareDisabled,
    isNextBusy,
    onShareScore,
    onNextPuzzle,
}: ScoreboardActionRowProps) {
    const outlineButtonClass =
        "tw-flex tw-h-9 tw-w-full tw-items-center tw-justify-center tw-gap-1.5 tw-rounded-[10px] tw-border tw-border-solid tw-border-white/15 tw-bg-transparent tw-text-[13px] tw-font-semibold tw-text-white hover:tw-opacity-90 disabled:tw-cursor-not-allowed disabled:tw-opacity-40";
    return (
        <div className="tw-grid tw-grid-cols-2 tw-gap-2 tw-px-4 tw-pb-3">
            <button type="button" className={outlineButtonClass} disabled={isShareDisabled} onClick={onShareScore}>
                <ShareGlyph color={isShareDisabled ? "rgba(255,255,255,0.4)" : "#fff"} />
                <span>Share score</span>
            </button>
            <button type="button" className={outlineButtonClass} disabled={isNextBusy} onClick={onNextPuzzle}>
                <span>Next puzzle</span>
                <ArrowRight size={12} color="#fff" aria-hidden="true" />
            </button>
        </div>
    );
}

